module.exports = __webpack_public_path__ + "img/Ellipse 1588.da020b8b.svg";